import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import {
    showHideModalSummary,
    registerCotizacion,
    updateInputs,
} from '../../actions/externoscotizaciones'


import { showHideModalDelete } from '../../actions/common'



class ModalSummary extends Component {
    handleCloseModal = () => {

        const modal = document.getElementById('modalSummary')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSummary .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalSummary(false), 300)
    }

    render() {

        const { modalSummary } = this.props

        if (!modalSummary.get('show')) {
            return null
        }

        const tipo_solicitud = modalSummary.getIn(['data', 'solicitud', 'tipo'])


        return(
            <Modal id="modalSummary" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ `Subir cotización` } onClose={ e => this.handleCloseModal(e, "modalSummary") } />
                <ModalButtonStrip>

                    <BoxButton
                        name="check"
                        title="Enviar cotización"
                        onClick={ () => this.props.registerCotizacion(modalSummary.getIn(['data', 'id']), 3) }
                    />



                </ModalButtonStrip>
                <ModalBody>

                    <div style={{ width: '800px' }}>
                    
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Responsable compras</label>
                                    <input type="text" className="form-control input-sm" value={modalSummary.getIn(['data', 'solicitud', 'responsable_compras', 'fullname'])} disabled />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Correo</label>
                                    <input type="text" className="form-control input-sm" value={modalSummary.getIn(['data', 'solicitud', 'responsable_compras', 'email'])} disabled />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Extensión</label>
                                    <input type="text" className="form-control input-sm" value={modalSummary.getIn(['data', 'solicitud', 'responsable_compras', 'extension'])} disabled />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Proyecto/Evento/Actividad</label>
                                    <input type="text" className="form-control input-sm" value={modalSummary.getIn(['data', 'solicitud', 'proyecto_evento'])} disabled/>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">No. Solicitud</label>
                                    <input type="text" className="form-control input-sm" value={modalSummary.getIn(['data', 'solicitud', 'id'])} disabled/>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Fecha solicitud</label>
                                    <input type="text" className="form-control input-sm" value={moment(modalSummary.getIn(['data', 'solicitud', 'created_at'])).format('DD/MM/YYYY')} disabled/>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="control-label">Fecha de entrega</label>
                                    <input
                                        type="date"
                                        className="form-control input-sm"

                                        value={moment(modalSummary.getIn(['data', 'fecha_entrega'])).format('YYYY-MM-DD')}


                                        onChange={(e) => this.props.updateInputs('modalSummary.data.fecha_entrega', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="row">

                            <div className="col-md-6">                            
                                <div className="form-group">
                                    <div className="form-group">
                                        <label className="control-label">
                                            {tipo_solicitud === 6 || tipo_solicitud === 7 ? "Descripción del bien" : "Descripción del servicio"}
                                        </label>
                                        <textarea 
                                            type="text" 
                                            className="form-control input-sm" 
                                            rows={2} 
                                            value={
                                                (tipo_solicitud === 6 || tipo_solicitud === 7) ?
                                                modalSummary.getIn(['data', 'bienes', 0, 'item', 'descripcion'])
                                                : modalSummary.getIn(['data', 'servicios', 0, 'descripcion']) }
                                            disabled
                                        />
                                    </div>                            
                                </div>                            
                            </div> 
                            <div className="col-md-2">                            
                                <div className="form-group">
                                    <div className="form-group">
                                        <label className="control-label">
                                            Cantidad
                                        </label>
                                        <input type="text" className="form-control input-sm"
                                            value={ (tipo_solicitud === 6 || tipo_solicitud === 7) ? 
                                                `${modalSummary.getIn(['data', 'bienes', 0, 'cantidad_solicitada'])} ${modalSummary.getIn(['data', 'bienes', 0, 'unidad'])} ` :
                                                modalSummary.getIn(['data', 'servicios', 0, 'cantidad']) } disabled />
                                    </div>                            
                                </div>                            
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">
                                        Subir cotización
                                    </label>
                                    <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                        <i className="fa fa-upload"></i> { modalSummary.getIn(['data','adjunto','file']) ? modalSummary.getIn(['data','adjunto','file']).name : ' Seleccione un archivo...' }
                                    </label>
                                </div>                             
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-info">
                                    Incluir toda la información necesaria en la cotización o de lo contrario enviar la información adicional al correo del Responsable de compras
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="control-label">Observaciones</label>
                                <textarea type="text" className="form-control input-sm" rows={4} value={ modalSummary.getIn(['data', 'observaciones']) || '' } onChange = { (e) => this.props.updateInputs('modalSummary.data.observaciones', e.target.value) } />
                            </div>
                        </div>
                    </div>

                    <div className="separator"></div>


                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSummary: state.externoscotizaciones.get('modalSummary'),
        enums: state.common.get('enums').toJS(),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalSummary: (state) => dispatch(showHideModalSummary(state)),
        showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
        registerCotizacion: (id, result) => dispatch(registerCotizacion(id, result)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSummary)


// WEBPACK FOOTER //
// ./src/components/ExternosCotizaciones/ModalSummary.jsx